"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFICATION_TYPE_DEFAULT_DEEP_LINK_TARGETS = exports.NOTIFICATION_PRESET_DEFAULT_DEEP_LINK_TARGETS = exports.NOTIFICATION_DEEP_LINK_TARGETS = exports.BLAST_DEEP_LINK_TARGETS = exports.NOTIFICATION_DEEP_LINK_TARGET_LABELS = void 0;
exports.resolveNotificationDeepLinkTarget = resolveNotificationDeepLinkTarget;
const enums_1 = require("../enums");
exports.NOTIFICATION_DEEP_LINK_TARGET_LABELS = {
  [enums_1.NotificationDeepLinkTarget.None]: 'None',
  [enums_1.NotificationDeepLinkTarget.AuthResume]: 'Auth resume',
  [enums_1.NotificationDeepLinkTarget.Map]: 'Map',
  [enums_1.NotificationDeepLinkTarget.MapVenueRsvp]: 'Map venue RSVP',
  [enums_1.NotificationDeepLinkTarget.MapLiveSignal]: 'Map live signal',
  [enums_1.NotificationDeepLinkTarget.VenuePeek]: 'Venue peek',
  [enums_1.NotificationDeepLinkTarget.EventsTab]: 'Events tab',
  [enums_1.NotificationDeepLinkTarget.UpcomingEvent]: 'Upcoming event',
  [enums_1.NotificationDeepLinkTarget.Venue]: 'Venue',
  [enums_1.NotificationDeepLinkTarget.User]: 'User profile',
  [enums_1.NotificationDeepLinkTarget.Conversation]: 'Conversation',
  [enums_1.NotificationDeepLinkTarget.Breadcrumb]: 'Breadcrumb',
  [enums_1.NotificationDeepLinkTarget.BreadcrumbReply]: 'Breadcrumb reply',
  [enums_1.NotificationDeepLinkTarget.VenueBreadcrumbComposer]: 'Venue breadcrumb composer',
  [enums_1.NotificationDeepLinkTarget.VenueBreadcrumbThread]: 'Venue breadcrumb thread',
  [enums_1.NotificationDeepLinkTarget.Account]: 'Account',
  [enums_1.NotificationDeepLinkTarget.FeedbackTopic]: 'Feedback topic'
};
/** Blast / scheduled blast compatible subset (legacy UI). */
exports.BLAST_DEEP_LINK_TARGETS = [enums_1.NotificationDeepLinkTarget.None, enums_1.NotificationDeepLinkTarget.VenuePeek, enums_1.NotificationDeepLinkTarget.EventsTab, enums_1.NotificationDeepLinkTarget.UpcomingEvent];
exports.NOTIFICATION_DEEP_LINK_TARGETS = Object.values(enums_1.NotificationDeepLinkTarget);
exports.NOTIFICATION_PRESET_DEFAULT_DEEP_LINK_TARGETS = {
  [enums_1.NotificationPresetTrigger.IncompleteOnboarding]: enums_1.NotificationDeepLinkTarget.AuthResume,
  [enums_1.NotificationPresetTrigger.OnboardedMapNotOpened]: enums_1.NotificationDeepLinkTarget.Map,
  [enums_1.NotificationPresetTrigger.MapOpenedNoRsvp]: enums_1.NotificationDeepLinkTarget.MapVenueRsvp,
  [enums_1.NotificationPresetTrigger.HabitLoopRsvpOrVisitPlanNoCheckin]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationPresetTrigger.HabitLoopCheckedInNoBreadcrumb]: enums_1.NotificationDeepLinkTarget.VenueBreadcrumbComposer,
  [enums_1.NotificationPresetTrigger.HabitLoopActiveUserIdleLiveSignal]: enums_1.NotificationDeepLinkTarget.MapLiveSignal,
  [enums_1.NotificationPresetTrigger.ResurrectionLapsedSend1]: enums_1.NotificationDeepLinkTarget.MapLiveSignal,
  [enums_1.NotificationPresetTrigger.ResurrectionLapsedSend2]: enums_1.NotificationDeepLinkTarget.MapLiveSignal,
  [enums_1.NotificationPresetTrigger.ResurrectionLapsedSend3]: enums_1.NotificationDeepLinkTarget.MapLiveSignal,
  [enums_1.NotificationPresetTrigger.LikeReceived]: enums_1.NotificationDeepLinkTarget.User,
  [enums_1.NotificationPresetTrigger.BreadcrumbLiked]: enums_1.NotificationDeepLinkTarget.VenueBreadcrumbThread,
  [enums_1.NotificationPresetTrigger.BreadcrumbReplyReceived]: enums_1.NotificationDeepLinkTarget.VenueBreadcrumbThread,
  [enums_1.NotificationPresetTrigger.MomentLiked]: enums_1.NotificationDeepLinkTarget.VenuePeek,
  [enums_1.NotificationPresetTrigger.MessageReceived]: enums_1.NotificationDeepLinkTarget.Conversation,
  [enums_1.NotificationPresetTrigger.ConversationFollowUp]: enums_1.NotificationDeepLinkTarget.Conversation,
  [enums_1.NotificationPresetTrigger.MyPlacesActivity]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationPresetTrigger.FeedbackReplyReceived]: enums_1.NotificationDeepLinkTarget.FeedbackTopic,
  [enums_1.NotificationPresetTrigger.VenueCheckedIn]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationPresetTrigger.VenueCheckedOut]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationPresetTrigger.NewUserCheckedInToVenue]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationPresetTrigger.AntiSpoofingLockReceived]: enums_1.NotificationDeepLinkTarget.Account,
  [enums_1.NotificationPresetTrigger.AdminLockReceived]: enums_1.NotificationDeepLinkTarget.Account,
  [enums_1.NotificationPresetTrigger.AdminUnlockReceived]: enums_1.NotificationDeepLinkTarget.Account,
  [enums_1.NotificationPresetTrigger.AutoUnlockReceived]: enums_1.NotificationDeepLinkTarget.Account
};
exports.NOTIFICATION_TYPE_DEFAULT_DEEP_LINK_TARGETS = {
  [enums_1.NotificationType.VenueBreadcrumbLiked]: enums_1.NotificationDeepLinkTarget.Breadcrumb,
  [enums_1.NotificationType.VenueBreadcrumbReplyReceived]: enums_1.NotificationDeepLinkTarget.BreadcrumbReply,
  [enums_1.NotificationType.VenueMomentLiked]: enums_1.NotificationDeepLinkTarget.VenuePeek,
  [enums_1.NotificationType.MessageReceived]: enums_1.NotificationDeepLinkTarget.Conversation,
  [enums_1.NotificationType.ConversationFollowUp]: enums_1.NotificationDeepLinkTarget.Conversation,
  [enums_1.NotificationType.LikeReceived]: enums_1.NotificationDeepLinkTarget.User,
  [enums_1.NotificationType.CheckedIn]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.CheckedOut]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.VenueClosed]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.NewUserCheckedInToVenue]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.AccountLocked]: enums_1.NotificationDeepLinkTarget.Account,
  [enums_1.NotificationType.AccountUnlocked]: enums_1.NotificationDeepLinkTarget.Account,
  [enums_1.NotificationType.OnboardingIncomplete]: enums_1.NotificationDeepLinkTarget.AuthResume,
  [enums_1.NotificationType.OnboardedMapNotOpened]: enums_1.NotificationDeepLinkTarget.Map,
  [enums_1.NotificationType.MapOpenedNoRsvp]: enums_1.NotificationDeepLinkTarget.MapVenueRsvp,
  [enums_1.NotificationType.Blast]: enums_1.NotificationDeepLinkTarget.VenuePeek,
  [enums_1.NotificationType.MyPlaces]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.MyPlaceNearby]: enums_1.NotificationDeepLinkTarget.Venue,
  [enums_1.NotificationType.FeedbackReplyReceived]: enums_1.NotificationDeepLinkTarget.FeedbackTopic
};
function resolveNotificationDeepLinkTarget(explicit, trigger, notificationType) {
  if (explicit !== null && explicit !== void 0 && explicit.trim()) {
    return explicit.trim();
  }
  if (trigger != null) {
    const fromTrigger = exports.NOTIFICATION_PRESET_DEFAULT_DEEP_LINK_TARGETS[trigger];
    if (fromTrigger) {
      return fromTrigger;
    }
  }
  if (notificationType != null) {
    const fromType = exports.NOTIFICATION_TYPE_DEFAULT_DEEP_LINK_TARGETS[notificationType];
    if (fromType) {
      return fromType;
    }
  }
  return null;
}
//# sourceMappingURL=notification-deep-link.js.map